import { service } from '@ember/service';
import Component from '@glimmer/component';
import CurrentUser from 'donor-elf-web/services/current-user';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarAdd from 'donor-elf-web/components/navbar-add';
import NavbarReports from 'donor-elf-web/components/navbar-reports';
import NavbarSearchContacts from 'donor-elf-web/components/navbar-search-contacts';
import { LinkTo } from '@ember/routing';
import { on } from '@ember/modifier';
import hasAbility from 'donor-elf-web/helpers/has-ability';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class TopNavbarFundComponent extends Component {
  @service declare currentUser: CurrentUser;
  @service declare fundsService: FundsService;
  classNames = ['flex-grow-1', 'd-flex'];

  writeFindFundInRubyToClipboard = () => {
    window.navigator.clipboard.writeText(
      `fund = Fund.find(${this.fundsService.selectedFund?.id})`,
    );
  };

  <template>
    <div class='mr-auto d-flex'>
      {{#if (hasAbility 'edit_contact')}}
        <div class='nav-item mr-3'>
          <NavbarAdd />
        </div>
      {{/if}}
      <div class='nav-item mr-3'>
        <NavbarReports />
      </div>
      <div class='nav-item mr-3'>
        <NavbarSearchContacts />
      </div>
    </div>
    {{#if this.currentUser.hasMultipleFunds}}
      <div class='nav-item'>
        <div class='selected-fund'>
          <div
            {{on 'click' this.writeFindFundInRubyToClipboard}}
            class='selected-fund-label'
            role='button'
          >
            Selected Fund
          </div>
          <div
            class='selected-fund-name svg-icon text-truncate'
            title={{this.fundsService.selectedFund.name}}
          >
            <LinkTo @route='funds'>
              {{this.fundsService.selectedFund.name}}
              <span class='text-brand'>
                {{svgJar 'angle-down'}}
              </span>
            </LinkTo>
          </div>
        </div>
      </div>
    {{/if}}
  </template>
}
